import {ButtonsActiveIndicatorDefaultBox} from "./buttons-active-indicator.default.box";

export const ButtonsActiveIndicatorBox =ButtonsActiveIndicatorDefaultBox;